import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import contentTypeName from '../../../utils/contentTypeName';
import MetaTags from '../Links/MetaTags';
import Icon from '../Icons/Icon';
import NewIcon from '../Icons/NewIcon';

const ContentTeaser = ({ href, title, summary, authorName, heroImage, streamImage, type, tcmAgeRange, usaAgeRange, hasVideo, isNew, userLocation, showImage, classes }) => {
  const containerClasses = classnames(`content-teaser-new card-link position-relative d-flex flex-column flex-grow-1 ${classes}`, {
    'content-teaser-new--new': isNew,
  });

  let teaserImageUrl;
  if (heroImage) {
    teaserImageUrl = heroImage;
  } else if (hasVideo && streamImage) {
    teaserImageUrl = streamImage;
  }

  return (
    <a href={href} className={containerClasses}>
      {showImage && teaserImageUrl &&
        <div className="content-teaser-new__image ratio-16-9-new background-size-cover" style={{ backgroundImage: `url(${teaserImageUrl})` }}>
          {hasVideo &&
            <div className="d-flex p-a-1 position-absolute absolute-center bg-white border-radius-100 box-shadow">
              <Icon name="play" size="m" fill="black" />
            </div>
          }
        </div>
      }

      <div className="content-teaser-new__text flex-grow-1">
        <h3 className="content-teaser-new__title card-link__text-change like-h4 fw-medium m-b-1">
          {title}
          {isNew && <NewIcon classes="m-l-1" />}
        </h3>
        <p className="content-teaser-new__author like-small m-b-2">By <span className="fw-medium">{authorName}</span></p>
        <p className="content-teaser-new_summary color-grey m-b-2">{summary}</p>
        <div className="content-teaser-new__meta-tags"><MetaTags type={contentTypeName(type)} tcmAgeRange={tcmAgeRange} usaAgeRange={usaAgeRange} userLocation={userLocation} /></div>
      </div>
    </a>
  );
};

ContentTeaser.propTypes = {
  href: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  summary: PropTypes.string,
  authorName: PropTypes.string.isRequired,
  heroImage: PropTypes.string,
  streamImage: PropTypes.string,
  type: PropTypes.string.isRequired,
  tcmAgeRange: PropTypes.string,
  usaAgeRange: PropTypes.string,
  hasVideo: PropTypes.bool,
  isNew: PropTypes.bool,
  userLocation: PropTypes.string,
  showImage: PropTypes.bool,
  classes: PropTypes.string,
};

export default ContentTeaser;



// WEBPACK FOOTER //
// ./library/app/components/Global/Teasers/ContentTeaser.js